import React from "react";
import { Globe, ChartBar, Gem, Code, BrainCircuit, Megaphone } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Office Cleaning",
  description: "Bespoke cleaning solutions for high-end corporate offices and executive suites, ensuring a pristine professional environment.",
  icon: Gem
}, {
  title: "Strata Cleaning",
  description: "Professional maintenance for common areas in premium residential and commercial strata buildings across the region.",
  icon: ChartBar
}, {
  title: "Gym & Fitness",
  description: "Specialized sanitization and high-frequency hygiene protocols tailored for health clubs and boutique fitness centers.",
  icon: BrainCircuit
}, {
  title: "Childcare & Daycare",
  description: "Safe, thorough, and chemical-conscious cleaning services designed for nurturing and educational environments.",
  icon: Megaphone
}, {
  title: "Commercial Property",
  description: "Comprehensive cleaning and facility management solutions for large-scale commercial assets and retail spaces.",
  icon: Globe
}, {
  title: "End of Lease",
  description: "Meticulous deep-cleaning services to ensure seamless property transitions and meet the highest commercial standards.",
  icon: Code
}];
export default function Services() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}